import { Combobox } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { ServiceFulfillmentPartnerFormSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";
import { useContacts } from "@/hooks/use-contacts";

export function ServiceFulfillmentPartnerForm() {
	/** Context */
	const methods = useFormContext<ServiceFulfillmentPartnerFormSchema>();

	/** Hooks */
	const { t } = useTranslation();

	/** Query */
	const { contacts } = useContacts();

	/** Render */
	return (
		<div className="v-stack gap-4">
			<Combobox
				control={methods.control}
				name="contactId"
				options={contacts}
				displayValue={(item) => item?.name || "n/a"}
				label={t("projects.fields.client")}
				keyExtractor={(item) => item?.id}
				placeholder={t("placeholders.company_name")}
				isRequired={false}
				data-cy="contact-input"
			/>
		</div>
	);
}
